import React from 'react';
import { number } from 'prop-types';
import Grid from '@mui/material/Grid';
import { activityCategories, isToggleEnabled } from '@paddl/utils-js';
import { ChartsWrapper, useViewportWidth, DoughnutChart, BarChart, ActivityColorPaletteLight, SectionHeader, Section } from '@paddl/storybook';
import { ProfileCharts_V2 } from './ProfileCharts_V2';
import { useResource } from '../../hooks/useResource';
const getCategoryTitle = categoryId => activityCategories().find(activityCategory => activityCategory.categoryId === categoryId).title;
const getCategoryColor = categoryId => ActivityColorPaletteLight[activityCategories().find(activityCategory => activityCategory.categoryId === categoryId).id];
export const ProfileCharts_V1 = _ref => {
  let {
    profileId
  } = _ref;
  const width = useViewportWidth();
  const {
    data: privateXpData
  } = useResource("".concat(process.env.API_PREFIX_V2, "/profiles-statistics/xp-by-category/").concat(profileId));
  const {
    data: publicXpData
  } = useResource("".concat(process.env.API_PREFIX_V2, "/public-profiles-statistics/skills/").concat(profileId));
  const {
    data: privateSkillsData
  } = useResource("".concat(process.env.API_PREFIX_V2, "/profiles-statistics/xp-by-category/").concat(profileId));
  const {
    data: publicSkillsData
  } = useResource("".concat(process.env.API_PREFIX_V2, "/public-profiles-statistics/skills/").concat(profileId));
  const isViewPortSmall = width === 'xs' || width === 'sm';
  const skills = (publicSkillsData === null || publicSkillsData === void 0 ? void 0 : publicSkillsData.skills) || (privateSkillsData === null || privateSkillsData === void 0 ? void 0 : privateSkillsData.skills) || [];
  const xpByCategory = (publicXpData === null || publicXpData === void 0 ? void 0 : publicXpData.xpByCategory) || (privateXpData === null || privateXpData === void 0 ? void 0 : privateXpData.xpByCategory) || [];
  const topSkills = skills.slice(0, 5);
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(SectionHeader, null, "Experience"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, /*#__PURE__*/React.createElement(ChartsWrapper, {
    headLine: "Top Skills",
    tagLine: "By number of Activities",
    tooltipText: "Shows the top 5 skills by the number of Activities they have been tagged in",
    shouldShowTooltip: !isViewPortSmall,
    chartBackgroundColor: "purple",
    chartPadding: "small"
  }, /*#__PURE__*/React.createElement(BarChart, {
    "data-test-id": "bar-chart",
    labels: topSkills.map(_ref2 => {
      let {
        name
      } = _ref2;
      return name;
    }),
    data: topSkills.map(_ref3 => {
      let {
        count
      } = _ref3;
      return count;
    })
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(ChartsWrapper, {
    headLine: "XP by Category",
    tagLine: "% of Total Experience",
    tooltipText: "Shows the % of Experience Points in each of the 6 Experience Categories.",
    shouldShowTooltip: !isViewPortSmall,
    chartBackgroundColor: "yellow",
    chartPadding: 'small'
  }, /*#__PURE__*/React.createElement(DoughnutChart, {
    "data-test-id": "doughnut-chart",
    label: "Xp by category",
    displayLegend: true,
    labels: xpByCategory.map(_ref4 => {
      let {
        categoryId
      } = _ref4;
      return getCategoryTitle(categoryId);
    }),
    backgroundColor: xpByCategory.map(_ref5 => {
      let {
        categoryId
      } = _ref5;
      return getCategoryColor(categoryId);
    }),
    data: xpByCategory.map(_ref6 => {
      let {
        collectedXpNumber
      } = _ref6;
      return collectedXpNumber;
    })
  })))));
};
ProfileCharts_V1.propTypes = {
  profileId: number.isRequired
};
export const ProfileCharts = props => {
  return isToggleEnabled('experience-records') ? /*#__PURE__*/React.createElement(ProfileCharts_V2, props) : /*#__PURE__*/React.createElement(ProfileCharts_V1, props);
};